import PropTypes from 'prop-types';
import React from 'react';
import { formatDateTime, TIME_ZONE } from 'helpers/dateTimeFormatter';
import TrendTooltipPointValueRow from './TrendTooltipPointValueRow';
import TrendTooltipMinMaxRow from './TrendTooltipMinMaxRow';
import { useTranslation } from 'react-i18next';

import './styles.scss';
import { IconDot } from 'svgIcons/MotionPortalIcons';
import colors from 'theme/_colors.scss';


const TrendTooltip = (props) => {
    const { t: translate } = useTranslation();
    const { points, timeStamp, isUTC, anomalyLevel } = props;
    const isPersonalLimit = points?.map(point => point?.series?.tooltipOptions?.isUserLimit).includes(true);
    return (
        <div className='custom-trend-tooltip'>
            <div className='t-header'>
                {isUTC ? `${formatDateTime(timeStamp, { timeZone: TIME_ZONE.UTC })} (${translate('ABB.Powertrain.Frontend.UTC')})` : formatDateTime(timeStamp)}
                {anomalyLevel > 0 &&
                    <div className='anomaly-point'>
                        <IconDot color={colors.orangePeel} />
                        <span>{translate('ABB.Powertrain.Frontend.conditionOverviewAnomalyPoint')}</span>
                    </div>
                }
            </div>
            {points?.map((point, kpiIndex) => {
                const isMinMax = point?.point?.low !== undefined;
                const uom = point?.series?.tooltipOptions?.valueSuffix?.trim() || '';
                const isPersonalLimits = point?.series?.tooltipOptions?.isUserLimit;
                return (
                    <div className='t-item' key={kpiIndex}>
                        {
                            isMinMax ? <TrendTooltipMinMaxRow point={point} uom={uom} /> : !isPersonalLimits
                                ? <TrendTooltipPointValueRow point={point} uom={uom} /> : null
                        }
                    </div>
                );
            })}
            {isPersonalLimit ? <span className='t-personal-limit'>{translate('ABB.Powertrain.Frontend.opTrendsLblPersonalLimit')}</span> : null}
            {isPersonalLimit ? points?.map((point, kpiIndex) => {
                const uom = point?.series?.tooltipOptions?.valueSuffix?.trim();
                const isPersonalLimits = point?.series?.tooltipOptions?.isUserLimit;
                return (
                    <div className='t-item' key={kpiIndex}>
                        {
                            isPersonalLimits ? <TrendTooltipPointValueRow point={point} uom={uom} />
                                : null
                        }
                    </div>
                );
            }) : null}
        </div>
    );
};

TrendTooltip.propTypes = {
    dateConfig: PropTypes.object,
    points: PropTypes.array,
    timeStamp: PropTypes.number,
    isUTC: PropTypes.bool,
    anomalyLevel: PropTypes.number
};

export default TrendTooltip;
